(function () {
  'use strict';

  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function onReady(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function initNewsletter(wrapper) {
    var form = wrapper.querySelector('.newsletter__form');
    if (!form) return;

    var successMessage = wrapper.getAttribute('data-success-message') || 'Thanks for subscribing.';
    var emailInput = form.querySelector('[name="contact[email]"]');
    var emailError = form.querySelector('[id^="newsletter-email-error-"]');
    var serverSuccess = form.querySelector('[id^="newsletter-success-shopify-"]');
    var errorBanner = form.querySelector('[id^="newsletter-error-banner-"]');

    function announce(message) {
      if (typeof announceToScreenReader === 'function') {
        announceToScreenReader(message);
      }
    }

    function validateEmail() {
      if (!emailInput || !emailError) return true;

      var value = emailInput.value.trim();
      var valid = value.length > 0 && EMAIL_PATTERN.test(value);

      if (!valid) {
        emailInput.setAttribute('aria-invalid', 'true');
        emailError.textContent = 'Please enter a valid email address.';
        emailError.hidden = false;
      } else {
        emailInput.removeAttribute('aria-invalid');
        emailError.textContent = '';
        emailError.hidden = true;
      }

      return valid;
    }

    if (emailInput) {
      emailInput.addEventListener('blur', function () {
        if (emailInput.value.trim().length > 0 || emailInput.getAttribute('aria-invalid') === 'true') {
          validateEmail();
        }
      });

      emailInput.addEventListener('input', function () {
        if (emailInput.getAttribute('aria-invalid') === 'true') {
          emailInput.removeAttribute('aria-invalid');
          if (emailError) {
            emailError.textContent = '';
            emailError.hidden = true;
          }
        }
      });
    }

    // Let Shopify handle the POST, redirects and server-rendered result.
    // Only intercept invalid input; a fetch cannot complete a challenge redirect.
    form.addEventListener('submit', function (event) {
      if (!validateEmail()) {
        event.preventDefault();
        if (emailInput) emailInput.focus();
        announce('Please enter a valid email address.');
      }
    });

    if (serverSuccess) {
      serverSuccess.focus();
      announce(successMessage);
      return;
    }

    if (errorBanner && !errorBanner.hidden) {
      errorBanner.focus();
      announce(errorBanner.textContent.trim());
    }
  }

  onReady(function () {
    var newsletters = document.querySelectorAll('[data-newsletter]');
    newsletters.forEach(initNewsletter);
  });
})();
